module.exports = __webpack_public_path__ + "static/media/radius-office.4d6603e1.png";